import { useCallback, useMemo, useState } from "react"
import { TableColumn } from "../interfaces"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function TableData({ rows, data, tableColumns, loading }: { tableColumns: TableColumn[], rows: Record<any, any>[], data: Record<any, any>, loading: boolean }) {

    const [internalState, setInternalState] = useState<{
        search: string
    }>({
        search: ''
    })

    const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInternalState({
            ...internalState,
            search: e.target.value
        })
    }

    const filtered = useMemo(() => rows.filter(project => {
        const search = internalState.search.toLowerCase()
        return tableColumns.map(col => {
            if (col.key === 'actions') return false
            let value = col.fn ? col.fn(project) : (project as any)[col.key]
            if (value === null || value === undefined) return false
            return value.toString().toLowerCase().includes(search)
        }).includes(true)
    }), [internalState.search, rows, tableColumns])


    return (
        <div>
            <div className="row">
                <div className="col-9">
                    <h5>Zobrazuje sa: {filtered.length}/{rows.length}</h5>
                </div>
                <div className="col-3">
                    <div className="input-group mb-3">
                        <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon fixedWidth icon={["fas", "search"]} /></span>
                        <input type="text" className="form-control" placeholder="Hľadať..." value={internalState.search} onChange={(e) => handleSearchInput(e)} />
                    </div>
                </div>
            </div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        {
                            tableColumns.map((col, index) => {
                                return (
                                    <th key={index} className={typeof col.className === "string" ? col.className : undefined} style={col?.style}>{col.title}</th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        loading ?
                            <tr>
                                <td colSpan={tableColumns.length} className="text-center" style={{ lineHeight: "5rem" }}>Nahrávajú sa dáta do tabuľky...</td>
                            </tr>
                            : filtered.length === 0 ?
                                <tr>
                                    <td colSpan={tableColumns.length} className="text-center" style={{ lineHeight: "5rem" }}>Nenašli sa žiadne záznamy ktoré by vyhovovali kritériám vyhľadávania</td>
                                </tr>
                                : filtered.sort((a, b) => (b.flag - a.flag || a.nameId.localeCompare(b.nameId))).map(project => {
                                    return (
                                        <tr>
                                            {
                                                tableColumns.map((col, index) => {
                                                    return (
                                                        <td key={index} className={typeof col.className === "string" ? col.className : col.className ? col.className(project) : undefined} style={col.style}>{col.fn ? col.fn(project) : (project as any)[col.key]}</td>
                                                    )
                                                })
                                            }

                                        </tr>
                                    )
                                })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default TableData;